import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {LogoutService} from '../services/logout.service';
import {AUTH0_EXPIRED_ERRORS} from './auth0-expired-errors';

@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {

    private redirecting = false;

    constructor(private logoutService: LogoutService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError(err => {
                if (this.redirecting) {
                    return throwError(() => err);
                }

                const isHttp401 = err instanceof HttpErrorResponse && err.status === 401;
                const isAuth0Expired = err?.error && AUTH0_EXPIRED_ERRORS.includes(err.error);

                if (isHttp401 || isAuth0Expired) {
                    this.redirecting = true;
                    console.warn('Session expired, forcing logout.', isHttp401 ? '(401)' : `(${err.error})`);
                    this.logoutService.logout();
                }

                return throwError(() => err);
            })
        );
    }
}
